module.exports = __webpack_public_path__ + "static/realtime2-6463de0b609776f1f9664b60d3120dd4.png";